import React from 'react';
export function Footer() {
  return <footer className="py-4 px-4 sm:px-6 bg-brand-violetDark text-center text-brand-pink/80 text-[10px] sm:text-xs" data-id="element-54" data-mp="32wd2qgad7ltj">
      <p className="font-semibold mb-1.5" data-id="element-55" data-mp="3ghc0pwojutll">© 2026 GYM RYTHMIQUE PRO™ — Tous droits réservés.</p>
      <p className="leading-snug max-w-2xl mx-auto font-medium mb-2" data-id="element-56" data-mp="32lrlpcbxyvjg">
        Les informations présentées dans ce système sont exclusivement destinées à des fins pédagogiques et
        professionnelles. Elles ne remplacent ni votre jugement professionnel, ni votre responsabilité en tant que
        professeur ou entraîneur. Adaptez toujours les exercices, les séances, les progressions et les planifications au
        niveau, aux capacités et aux objectifs de chacune de vos gymnastes.
      </p>
      <div className="flex justify-center gap-2 sm:gap-3 font-bold tracking-wide" data-id="element-57" data-mp="3qfjgic73r5m0">
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-58" data-mp="29xvq6ay3z9o9">
          Conditions Générales
        </a>
        <span data-id="element-59" data-mp="2ew70emsbfm70">•</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-60" data-mp="3l9adtjp9964y">
          Politique de Confidentialité
        </a>
        <span data-id="element-61" data-mp="3gb8wp4be3gw4">•</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-62" data-mp="3gbqxme8zyjad">
          Contact
        </a>
      </div>
    </footer>;
}